module.exports = __webpack_public_path__ + "static/media/user.c8c4b869.svg";